import React, { PureComponent } from 'react'
import { KTColors } from '../../Constants/KTColors'
import {
  heightPercentageToDP as heightPercentage,
  widthPercentageToDP as widthPercentage,
} from '../../../Utils/ResponsiveScreen'
import { fonts } from '../../Constants/theme'
import _ from 'lodash'
import DynamicButtonView from '../DynamicButtonView'
import AwsConfig from '../../../Config/AwsConfig'

const styles = {
  pollTitle: {
    textAlign: 'center',
    // fontFamily: fonts.fontFamilyPoppinsLight,
    fontSize: heightPercentage('2.8%'),
    // fontWeight: 'bold',
    marginBottom: heightPercentage('1%'),
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    fontSize: heightPercentage('2.4%'),
    lineHeight: heightPercentage('3%'),
    fontFamily: fonts.fontFamilyPoppinsLight,
  },
  button: {
    borderWidth: 0.8,
    opacity: 0.8,
    width: widthPercentage('90%'),
    marginTop: heightPercentage('1.5%'),
  },
}
class PollContentView extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { content, pollTitle, pollDescription, contentVisibleLang } = this.props

    const {
      pollOriginalImages,
      pollImage,
      pollPositionFromTop,
      textColor,
      pollBgColor,
      pollInfo,
    } = content.contentMetaInfo.pollDetails
    const originalImg = pollOriginalImages?.[0]?.imageValue || pollOriginalImages?.[0]?.image
    const pollImg = pollOriginalImages ? originalImg : pollImage ? pollImage[0].image : ''
    let cdnurl = AwsConfig.cdn_url
    const imageWithcdn = pollImg ? pollImg.includes(cdnurl) ? pollImg : cdnurl + pollImg : ''
    const pollPosition = pollPositionFromTop ? pollPositionFromTop : 40
    const pollTextColor = textColor ? textColor : KTColors.white
    const bgColor = pollBgColor ? pollBgColor : 'red'

    const fullWidthOfOption = 90
    const halfWidthOfOption = 43
    const splitPollOptions = pollInfo?.length > 5
    const widthOfOption = splitPollOptions ? halfWidthOfOption : fullWidthOfOption
    return (
      <div
        style={{
          height: heightPercentage('100%'),
          width: widthPercentage('100'),
          backgroundImage: `url(${imageWithcdn})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div>
          <div
            style={{
              alignItems: 'center',
              alignSelf: 'center',
              justifyContent: 'center',
              paddingTop: heightPercentage(pollPosition),
            }}
          >
            <div
              style={{
                backgroundColor: bgColor,
                padding: heightPercentage('3'),
              }}
            >
              <p style={{ ...styles.pollTitle, ...{ color: pollTextColor } }}>{pollTitle}</p>
              <div
                style={{
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  width: widthPercentage('90'),
                }}
              >
                {pollInfo?.map((item) => {
                  const pollOption = item[`choice_${contentVisibleLang}`]
                  return (
                    <button
                      style={{
                        textAlign: 'center',
                        color: pollTextColor,
                        paddingLeft: widthPercentage('3%'),
                        paddingRight: widthPercentage('3%'),
                        paddingTop: widthPercentage('2%'),
                        paddingBottom: widthPercentage('2%'),
                        borderStyle: 'solid',
                        borderColor: pollTextColor,
                        borderRadius: 5,
                        backgroundColor: 'transparent',
                        width: widthPercentage(`${widthOfOption}`),
                        marginBottom: heightPercentage('1.5%'),
                        marginRight: widthPercentage('1.5'),
                      }}
                    >
                      {pollOption}
                    </button>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        {this.props.contentNewLinkDetails?.map((item) => {
          return <DynamicButtonView contentNewLinkDetails={item} />
        })}
      </div>
    )
  }
}

export default PollContentView
